"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Email from foundation/Email
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Envelope = createSVGIcon(
  <>
    <rect
      stroke="currentColor"
      x=".5"
      y=".5"
      width="13.4"
      height="11"
      rx=".5"
    />
    <path stroke="currentColor" d="m.9 11.7 4.41-5.4m8.19 5.4L9.09 6.3" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m.9.9 5.547 6.34a1 1 0 0 0 1.505 0L13.5.9"
    />
  </>,
  "Envelope",
  { viewBox: "0 0 15 13", titleAccess: "Envelope", fill: "none" }
);
